import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContractsService } from '../../../services/contracts.service';
import { ErrorService } from '../../../shared/services/error.service';
import { TableAction } from '../../../shared/components/table/table.component';

@Component({
  selector: 'app-b2b-portal-users-hub',
  templateUrl: './b2b-portal-users-hub.component.html',
  styleUrls: ['./b2b-portal-users-hub.component.css']
})
export class B2bPortalUsersHubComponent implements OnInit {
  contracts: any[] = [];
  isLoading = false;
  searchTerm = '';
  pageNumber = 1;
  pageSize = 10;
  totalItems = 0;
  totalPages = 0;

  columns = [
    { titulo: 'Número', label: 'contractNumber' },
    { titulo: 'Nome', label: 'contractName' },
    { titulo: 'Empresa', label: 'companyName' },
    { titulo: 'Status', label: 'statusLabel' },
  ];

  actions: TableAction[] = [
    {
      label: 'Usuários e acessos',
      icon: 'fas fa-user-shield',
      action: 'portal-users',
      class: 'btn-edit',
      visible: true
    }
  ];

  constructor(
    private router: Router,
    private contractsService: ContractsService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.loadContracts();
  }

  loadContracts(): void {
    this.isLoading = true;
    this.contractsService.listB2bContracts(this.pageNumber, this.pageSize).subscribe({
      next: (res: any) => {
        const raw = res?.data ?? res?.Data ?? res?.items ?? [];
        const list = Array.isArray(raw) ? raw : [];
        this.contracts = list
          .map((c: any) => this.toRow(c))
          .filter((c: any) => this.matchesSearch(c));

        const pag = res?.pagination ?? res?.Pagination ?? {};
        this.totalItems = pag.totalItems ?? pag.TotalItems ?? this.contracts.length;
        this.totalPages = pag.totalPages ?? pag.TotalPages
          ?? Math.max(1, Math.ceil(this.totalItems / Math.max(1, this.pageSize)));
        this.pageNumber = pag.currentPage ?? pag.CurrentPage ?? this.pageNumber;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.errorService.handleHttpError(err);
      }
    });
  }

  private toRow(c: any): any {
    return {
      id: c.id ?? c.Id,
      contractNumber: c.contractNumber ?? c.ContractNumber ?? '',
      contractName: c.contractName ?? c.ContractName ?? '',
      companyName: c.companyName ?? c.CompanyName ?? '',
      statusLabel: c.statusLabel ?? c.status ?? c.Status ?? '—'
    };
  }

  private matchesSearch(c: any): boolean {
    if (!this.searchTerm?.trim()) return true;
    const t = this.searchTerm.trim().toLowerCase();
    return [c.contractNumber, c.contractName, c.companyName]
      .some((v: string) => (v || '').toLowerCase().includes(t));
  }

  onSearchChange(term: string): void {
    this.searchTerm = term || '';
    this.pageNumber = 1;
    this.loadContracts();
  }

  onPageChange(page: number): void {
    if (!page || page === this.pageNumber) return;
    this.pageNumber = page;
    this.loadContracts();
  }

  onPageSizeChange(size: number): void {
    this.pageSize = size > 0 ? size : 10;
    this.pageNumber = 1;
    this.loadContracts();
  }

  onActionClick(event: { action: string; item: any }): void {
    if (event.action === 'portal-users' && event.item?.id) {
      this.router.navigate(['/b2b/contracts', event.item.id, 'portal-users']);
    }
  }
}
